import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import AddItem from '../../../shared/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import Item from '../../../shared/Education/Item';
import Certifications from './Certifications';

const EducationTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');
  const isAllDisabled = data.education.items.every((item) => !item.enable);
  const isAllEnabled = data.education.items.every((item) => item.enable);

  useEffect(() => {
    if (isAllDisabled) {
      onChange('data.education.enable', false);
    }
    if (isAllEnabled && !data.education.enable) {
      onChange('data.education.enable', true);
    }
    // eslint-disable-next-line
  }, [isAllDisabled, isAllEnabled]);

  return (
    <>
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab col-span-5">{t('education.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.education.enable}
              onChange={(v) => onChange('data.education.enable', v)}
              preLabel="Show on CV"
            />
          </div>
        </div>

        <DragNDropList data={data} dispatch={dispatch} onChange={onChange} type="education">
          {data.education.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.education.items.length - 1}
            />
          ))}
        </DragNDropList>

        <AddItem
          heading={data.education.heading}
          dispatch={dispatch}
          existingItems={data.education.items}
        />
      </>

      <Certifications data={data} onChange={onChange} />
    </>
  );
};

export default EducationTab;
